import React from "react";
import { waLink } from "@/config";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat({ message }) {
  return (
    <a
      data-testid="whatsapp-float"
      href={waLink(message)}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
    >
      <MessageCircle size={26} />
    </a>
  );
}
